import {Stack, Typography} from '@mui/material';
import React from 'react';

import {HEALTH_CARD_MENU_ITEM_ID} from 'presentation/components/Navigation/constants';
import Tutorial from 'presentation/components/Tutorial';
import {translations} from 'presentation/translations-new';
import {Placement} from 'react-joyride';
import {WaitingPeriodTutorialProps} from './types';

const {title, description, action} = translations['pt-br'].privateFlow.home.waitingPeriodTutorial;

export function WaitingPeriodTutorial({onComplete}: WaitingPeriodTutorialProps) {
	return (
		<Tutorial
			steps={[
				{
					target: `#${HEALTH_CARD_MENU_ITEM_ID}`,
					content: (
						<Stack gap={1}>
							<Typography variant="subtitle1" fontWeight={600}>
								{title}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{description}
							</Typography>
						</Stack>
					),
					placement: 'right' as Placement,
					disableBeacon: true,
				},
			]}
			storageKey={HEALTH_CARD_MENU_ITEM_ID}
			onComplete={onComplete}
			customButtonsLabels={{last: action}}
			disableScrollParentFix={false}
			disableOverlayClose
		/>
	);
}
